import {
  Container,
  Grid,
  ThemeProvider,
  Typography,
  makeStyles,
  Button,
  Modal,
} from "@material-ui/core";
import { ITheme, theme } from "../constants/theme";

import { CancelButton, Stamp } from "../components-atoms";
import { roleName } from "../utils/roles";
import { GavelRounded, CreditCard } from "@material-ui/icons";
import BackButton from "../components-atoms/BackButton";
import { buttonHoverAndActive } from "../utils/styles/buttonStyles";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import OrderHeaderActions from "./OrderHeaderActions";

export const OrderDetailsHeaderSection = (props: any) => {
  const { t } = useTranslation();
  const [refundModal, setRefundModal] = useState(false);
  const data = props.data;
  const isFailed = data.Status === "FailedDelivery";
  const isDelivered = data.Status === "DeliveredDelivery";

  const classes = useStyles();
  let orderState = "";
  switch (data.ShopPortalStatus) {
    case "Pending":
      orderState = "Open orders";
      break;
    case "Queued":
      orderState = "Ready for collection";
      break;
    case "Archived":
      orderState = "Archive";
      break;
    case "Failed":
      orderState = "Failed Deliveries";
      break;
    default:
      break;
  }

  function renderRefundModal() {
    return (
      <Modal
        open={refundModal}
        onClose={props.onClose}
        className={classes.modal}
      >
        <Container className={classes.modalContainer}>
          <Grid container spacing={1}></Grid>
          <Grid item className={classes.titleSection}>
            <Typography variant="h6" component="h6" color="textPrimary">
              Mark as refunded
            </Typography>
          </Grid>
          <Grid item className={classes.bodySection}>
            <Grid item container direction="row">
              <Typography variant="body2" component="p" color="textPrimary">
                {"You are about to mark this order as refunded "}
              </Typography>
              <Typography
                variant="body2"
                component="p"
                data-automation="order-number"
                color="textPrimary"
                style={{ fontWeight: "bold", marginLeft: 3 }}
              >
                {data.OrderNo}
              </Typography>
            </Grid>
            <Typography
              variant="body2"
              component="p"
              className={classes.mt8}
              color="textPrimary"
            >
              Are you sure you want to mark this order as refunded?
            </Typography>
          </Grid>
          <Grid item container xs={12} justifyContent="flex-end">
            <CancelButton onClick={() => setRefundModal(false)} />
            <Button onClick={props.onRefund} className={classes.rejectButton}>
              <Typography
                variant="button"
                component="p"
                color="inherit"
                data-automation="confirm-reject-order"
              >
                Yes, mark as refunded
              </Typography>
            </Button>
          </Grid>
        </Container>
      </Modal>
    );
  }

  return (
    <Container className={classes.header}>
      <ThemeProvider theme={theme}>
        <Grid container direction="row">
          <Grid xs={1} item container>
            <Grid
              item
              container
              alignItems="center"
              justifyContent="center"
              xs={12}
            >
              <BackButton onClick={props.onBackClicked} />
            </Grid>
          </Grid>
          <Grid item xs={6} className={classes.headerOrderDetailSection}>
            <Grid item>
              <Typography
                variant="body1"
                component="p"
                color="textSecondary"
                className={classes.headerSubtitle}
              >
                {orderState}
              </Typography>
            </Grid>
            <Grid item container>
              <Grid item>
                <Typography variant="h5" component="h1" color="textPrimary">
                  {data?.OrderNo}
                </Typography>
              </Grid>
              {data.Cancelled !== null ? (
                <Stamp type="fail" text="Cancelled Order" />
              ) : (
                <></>
              )}
              {data.Status === "AuthorizationRequired" ||
              data.ProOrderStatus === "Authorization Required" ? (
                <Stamp type="fail" text="Authorisation Required" />
              ) : (
                <></>
              )}
              {data.Status === "RejectedDelivery" ? (
                <Stamp type="fail" text="Rejected Order" />
              ) : (
                <></>
              )}
              {data.ProOrderStatus === "Rejected By Manager" ? (
                <Stamp type="fail" text="Rejected By Manager" />
              ) : (
                <></>
              )}
              {data.ProOrderStatus === "Pending Approval" ? (
                <Stamp type="warning" text="Pending Approval" />
              ) : (
                <></>
              )}
              {!data.Delivered &&
              !data.Failed &&
              !data.Cancelled &&
              data.OutForDelivery !== null ? (
                <Stamp type="warning" text="Out for Delivery" />
              ) : (
                <></>
              )}
              {data.Delivered !== null ? (
                <Stamp type="success" text="Delivered" />
              ) : (
                <></>
              )}
              {data.Failed && data.ShopPortalStatus !== "Archived" ? (
                <Stamp type="fail" text="Failed Delivery" />
              ) : (
                <></>
              )}
              {data.ManuallyRefunded !== null &&
              data.ShopPortalStatus === "Archived" ? (
                <Stamp type="refunded" text="Refunded" />
              ) : (
                <></>
              )}

              {data.ManuallyResolved ? (
                <Stamp type="info" text="Manually resolved" />
              ) : (
                <></>
              )}
            </Grid>
          </Grid>
          <Grid
            item
            alignItems="center"
            justifyContent="flex-end"
            container
            className={classes.headerButtonContainer}
            xs={5}
          >
            {isFailed && roleName() === "Admin" ? (
              <Button
                data-automation="resolve-button"
                variant="contained"
                color="primary"
                disableElevation
                className={classes.primaryButton}
                style={{
                  paddingLeft: props.loading ? "12px" : "16px",
                }}
                startIcon={<GavelRounded fontSize="inherit" />}
                onClick={props.onResolveButtonPress}
              >
                {t("admin.resolve")}
              </Button>
            ) : (
              <></>
            )}
            {isDelivered && roleName() === "Admin" ? (
              <>
                {renderRefundModal()}
                <Button
                  data-automation="resolve-button"
                  variant="contained"
                  color="primary"
                  disableElevation
                  className={classes.primaryButton}
                  style={{ paddingLeft: "16px" }}
                  startIcon={<CreditCard fontSize="inherit" />}
                  onClick={() => setRefundModal(true)}
                >
                  {t("admin.markAsRefunded")}
                </Button>
              </>
            ) : null}
            {roleName() === "Admin" ? <OrderHeaderActions data={data} /> : null}
          </Grid>
        </Grid>
      </ThemeProvider>
    </Container>
  );
};
const useStyles = makeStyles((theme: ITheme) => ({
  header: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  headerOrderDetailSection: {},
  headerSubtitle: {
    marginBottom: 4,
  },
  headerButtonContainer: {
    paddingRight: 24,
  },
  primaryButton: {
    marginLeft: 8,
    borderRadius: 8,
    ...buttonHoverAndActive,
  },
  modal: { alignItems: "center", justifyContent: "center" },
  modalContainer: {
    backgroundColor: "white",
    maxWidth: "480px",
    boxShadow:
      "0px 6px 36px rgba(0, 0, 0, 0.15), 0px 2.21728px 14.2392px rgba(0, 0, 0, 0.111884), 0px 0.93179px 6.99399px rgba(0, 0, 0, 0.0997219), 0px 0.37078px 3.36556px rgba(0, 0, 0, 0.0894965), 0px 0.120827px 1.42249px rgba(0, 0, 0, 0.0753326), 0px 0.0225271px 0.422798px rgba(0, 0, 0, 0.0508791)",
    borderRadius: "20px",
    padding: "24px",
    margin: "0",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },

  titleSection: {
    marginBottom: "8px",
  },
  bodySection: {
    marginTop: 16,
    marginBottom: 32,
  },
  rejectButton: {
    borderRadius: "8px",
    padding: "6px 16px",
    backgroundColor: theme.palette.primary.main,
    color: "white",
    "&:hover": {
      backgroundColor: theme.palette.primary[92],
    },
    "&:active": {
      backgroundColor: theme.palette.primary[76],
    },
  },
  mt8: {
    marginTop: 8,
  },
}));
